<template>
  <div class="emp-audit-wrap pa-3">
    <div class="row">
      <div class="text-left" :class="chatInitDate.endDate || selectedType ? 'col-4' : 'col-4'">
        <div class="a-heading px-0 mx-0 my-0" style="">Audit logs of campaign</div>
      </div>
      <v-col class="px-1" :class="chatInitDate.endDate || selectedType ? 'col-3' : 'col-4'">
        <v-dialog
            ref="menu"
            v-model="menu"
            :return-value.sync="dates"
            persistent
            width="max-content"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              label="Select date range"
              dense
              v-model="dates"
              append-icon="fas fa-calendar"
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker
              range
              scrollable
              v-model="dates"
              color="primary"
              :min="chatInitDate.minDate"
              :max="chatInitDate.maxDate"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(dates);updateInitDate(dates)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
      </v-col>
      <div class="col-4 text-left">
        <v-select
          v-model="selectedType"
          :items="auditType"
          item-text="name"
          dense
          item-value="value"
          label="Filter by type"
        ></v-select>
      </div>
      <v-col cols="1" v-if="chatInitDate.endDate || selectedType">
        <v-btn icon text @click="clearFilter()"><v-icon>las la-times</v-icon></v-btn>
      </v-col>
    </div>
    <div class="list-wrap" v-if="auditData.length > 0">
    <div class="row mx-2" style="margin-top:-1%;">
      <div class="col-4 text-left"  style="max-width:30%;">
          User
        </div>
        <div class=" text-left col-2">
          Date
        </div>
        <div class=" text-left col-2">
          IP
        </div>
        <div class=" text-left col-4">
          Description
        </div>
      </div>
      <div
        class="list-item row elevation-0 px-0 ma-2 bg-white campaign-row" style="border-radius: 6px;"
        v-for="(i,index) in auditData"
        :key="index"
      >
        <div class="col-4" style="max-width:30%;" :name="`tippy01${index}`">
          <div style="display:inline-block; vertical-align:top;margin-top:6px;margin-right: 5px;">
            <v-avatar color="primary" size="35">
              <span class="white--text headline">
                {{i.created_by.display_name.charAt(0)}}
              </span>
            </v-avatar>
          </div>
          <div  style="display:inline-block">
            <div class="a-name">{{i.created_by.display_name}}</div>
            <div>{{i.created_by.email}}</div>
          </div>
          <tippy :to="`tippy01${index}`"
            interactive="true"
            theme="light amara"
            class="am-tool"
            :allowHTML="true"
            arrow
            placement="right"
            >
            <p class="text-left w-100">Browser : {{i.user_agent.browser}}</p>
            <p class="text-left w-100">Browser version : {{i.user_agent.browser_version}}</p>
            <p class="text-left w-100">OS : {{i.user_agent.os}}</p>
            <p class="text-left w-100">OS version : {{i.user_agent.os_version}}</p>
            </tippy>
        </div>
        <div class="col-2">
          {{dayjs(i.created_at).format('DD-MMMM-YYYY')}}<br>
          {{dayjs(i.created_at).format('hh:mm:ss A')}}
        </div>
        <div class="col-2">
          {{i.user_agent.client_ip}}
        </div>
        <div class="col-4">
          {{i.description}}
        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
        <span slot='no-more'>{{' '}}</span>
        <span slot='no-results'>{{' '}}</span>
      </infinite-loading>
    </div>
      <div v-if="auditData && auditData.length === 0" class="pa-4 d-flex align-center text-center">
        <p class="w-100 text-center">No records found</p>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
// import { VAvatar } from 'vuetify';
import dayjs from 'dayjs';
import InfiniteLoading from 'vue-infinite-loading';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  name: 'EmpAuditLog',
  props: {
    campaignDetails: {
      required: true,
      type: Array
    }
  },
  components: {
    // VAvatar,
    InfiniteLoading
  },

  data () {
    return {
      dates: [],
      joinDateMenu: false,
      startDate: '',
      exitDateMenu: false,
      endDate: dayjs().format('DD-MM-YYYY'),
      selectedType: '',
      auditType: [{
        name: 'Adhoc Survey Share Logs',
        value: 'share_logs'
      }, {
        name: 'Adhoc Survey Response Download logs',
        value: 'download_logs'
      }],
      menu: false,
      auditData: [],
      page: 1,
      select: '',
      chatInitDate: {
        startDate: undefined,
        endDate: undefined,
        format: 'DD/MM/YYYY',
        minDate: dayjs('01/01/2018').format(),
        maxDate: dayjs().format()
      }
    };
  },

  mounted () {
    this.infiniteHandler();
  },
  watch: {
    selectedType () {
      this.page = 1;
      this.auditData = [];
      this.infiniteHandler();
    }
  },
  methods: {
    clearFilter () {
      this.dates = [];
      this.chatInitDate.startDate = null;
      this.chatInitDate.endDate = null;
      this.selectedType = '';
      this.page = 1;
      this.auditData = [];
      this.infiniteHandler();
    },
    updateInitDate (date) {
      if (date) {
        this.chatInitDate.startDate = date[0];
        this.chatInitDate.endDate = date[1];
        this.page = 1;
        this.auditData = [];
        this.infiniteHandler();
      }
    },
    downloadFile (url) {
      window.open(url);
    },
    /*eslint-disable*/
    infiniteHandler ($state) {
      axios.get(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.campaignDetails.stage_id}/audit_logs/`, {
        params: {
          'page-offset': this.page,
          'created_at_start': this.chatInitDate.startDate ? this.chatInitDate.startDate : undefined,
          'created_at_end': this.chatInitDate.startDate ? this.chatInitDate.endDate : undefined,
          'type__in': this.selectedType ? this.selectedType : undefined
        }
      }).then((response) => {
        if (response.data.count > this.auditData.length) {
          this.page += 1;
          const temp = [];
          if (this.auditData.length > 0) {
            this.$lodash.each(this.auditData, (val) => {
              temp.push(val);
            });
          }
          this.$lodash.each(response.data.results, (val) => {
            temp.push(val);
          });
          this.auditData = temp;
          $state.loaded();
        } else {
          $state.complete();
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
    },
    getAudit () {
    }
  }
};
</script>

<style lang="scss" scoped>
.emp-audit-wrap {
  .a-heading {
    margin: 12px;
    padding: 12px;
    font-size: 18px;
    font-weight: 600;
  }
  .list-wrap {
    height: 80vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
